<template>
  <div v-show="startRender" class="attention-check">
    <div class="main_top transparent">
      <h1><img src="images/basic/icon/back-w.svg" onclick="history.back()" class="back" />출석 체크</h1>
    </div>

    <div class="attention-detail">
      <div class="attention">
        <div class="text">
          <h2>
            출석체크하면 채굴권!<br />
            5일 연속 출석하면 2배로!
          </h2>
          <p>
            하루 한번 출석체크시 바로 지급하며, <br />
            24:00시에 새로 출석이 가능합니다.
          </p>
        </div>
        <img src="/images/basic/img/attention-detail.png" alt="" srcset="/images/basic/img/attention-detail.png 1x, /images/basic/img/attention-detail@2x.png 2x, /images/basic/img/attention-detail@3x.png 3x" class="img" />
      </div>
      <div class="calendar">
        <div class="status">
          <div class="current_date">{{ year }}.{{ month }}</div>
          <div class="myAttendanc">
            나의 출석일 <span>{{ checkCnt }}일</span>
          </div>
        </div>
        <div class="calendar__day_wrap">
          <div class="calendar__day">일</div>
          <div class="calendar__day">월</div>
          <div class="calendar__day">화</div>
          <div class="calendar__day">수</div>
          <div class="calendar__day">목</div>
          <div class="calendar__day">금</div>
          <div class="calendar__day">토</div>
        </div>
        <div class="calendar__date">
          <div class="calendar__number" v-for="(date_num, idx) in dateList" :key="idx" :class="[{ past: date_num.past }, date_num.num == today ? 'today' : '']" @click="checkMyAttendance(date_num.num == today)">
            <template v-if="date_num.attend">
              <img class="att_sticker" src="/images/basic/icon/icon-stamp-attention copy 2.svg" alt="" width="80%" />
            </template>
            <template v-else>
              <div>{{ date_num.num }}</div>
            </template>
          </div>
        </div>
        <div class="end" v-if="check == 'Y'">
          <p>출석 완료</p>
        </div>
        <div class="check_btn" v-else @click="checkMyAttendance(true)">
          <p>출석 체크하기</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { fetchCalendarInfo, checkAttendance } from "@/api/daily";
export default {
  created() {
    window.VueRoot=this;
    fetchCalendarInfo()
      .then(({ data }) => {
        let result = data.result;
        this.month = result.month;
        this.year = result.year;
        this.today = result.today;
        this.checkCnt = result.checkCnt;
        this.check = result.check;
        if (result.checkDateList) {
          this.checkDateList = result.checkDateList;
        }

        for (let i = 1; i < result.lastDayNum + 1; i++) {
          var date = new Object();
          date.num = i;
          if (i < this.today) {
            date.past = true;
          } else {
            date.past = false;
          }
          if (!this.checkDateList.includes(i)) {
            date.attend = false;
          } else {
            date.attend = true;
          }
          this.dateList.push(date);
        }

        switch (result.startWeekNum) {
          case 1:
            this.defaultLength = 0;
            break;
          case 2:
            this.defaultLength = 1;
            break;
          case 3:
            this.defaultLength = 2;
            break;
          case 4:
            this.defaultLength = 3;
            break;
          case 5:
            this.defaultLength = 4;
            break;
          case 6:
            this.defaultLength = 5;
            break;
          case 7:
            this.defaultLength = 6;
            break;
        }

        for (let i = 0; i < this.defaultLength; i++) {
          this.dateList.unshift({});
        }
        this.startRender = true;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {
    setTimeout(function(){
      window.VueRoot.autoScrollCalendar();
    },this.AUTO_SCROLL_TM);
  },
  data() {
    return {
      startRender: false,
      dateList: [],
      attendedEvent: false,
      today: 0,
      month: "",
      year: "",
      checkCnt: 0,
      check: "",
      checkDateList: [],
      defaultLength: 0,
      startRequest: false,

      AUTO_SCROLL_TM: 2000, // 시작 AUTO SCROLL Time in mill

    };
  },
  methods: {
    checkMyAttendance(today) {
      if (this.check == "N") {
        if(!today) return;
        if(this.startRequest){
          return;
        }
        this.startRequest = true;
        checkAttendance().then(({ data }) => {
          this.startRequest = false;
          let result = data.resultCode;
          if (result == 1000) {
            this.check = "Y";
            this.dateList.forEach((el) => {
              if (el.num == this.today) {
                el.attend = true;
              }
            });
            this.checkCnt += 1;
            alert("출석체크를 완료했습니다.");
          }
          if (result == 2200) {
            alert("이미 출석체크를 완료했습니다.");
          }
        });
      }
    },
    autoScrollCalendar(){
      let window_height = $(window).height();
      let top_height = $('.attention').innerHeight();
      let btm_height = $('.calendar').innerHeight();
      let target = window_height - top_height - btm_height;
      let down_result = target + 86;
      if(target < -20) {
        $('.calendar').animate({
          'margin-top' : target
        },500);

        $('.calendar').on({
          'touchmove':function(e){
            var moveY = e.originalEvent.changedTouches[0].clientY;
            console.log(moveY);
            console.log(down_result);
            if(moveY++){
              if(down_result < 0){
                $('.calendar').animate({
                  'margin-top' : -24
                },500);
              }
            }
          }
        })
      }


    }
  },
};
</script>

<style scoped>
.calendar {
  position: relative;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 5px 50px rgba(#000, 0.5);
  border-radius: 8px;
  overflow: hidden;
  padding: 10px;
  margin: auto;
}

.calendar .status {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.calendar .status .current_date {
  font-size: 18px;
  font-weight: 600;
}

.calendar .status .myAttendanc {
  font-size: 14px;
}

.calendar .status .myAttendanc span {
  font-size: 14px;
  color: #ff7100;
}

.calendar__date {
  padding: 10px 10px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.calendar__day_wrap {
  padding: 10px 10px;
  display: flex;
  border-bottom: 1px solid rgba(158, 163, 171, 0.5);
  border-top: 1px solid rgba(158, 163, 171, 0.5);
}

.calendar__day {
  width: 14.28%;
  height: 25px;
  text-align: center;
  font-weight: 600;
  color: #9ea3ab;
}

.check_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 56px;
  margin: 10px 0 10px 0;
  transition: 0.4s;
  overflow: hidden;
  color: white;
  background: linear-gradient(to right, #ffb800, #ff7100);
  font-size: 16px;
}

.end {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 56px;
  margin: 30px 0 10px 0;
  transition: 0.4s;
  overflow: hidden;
  color: white;
  font-size: 16px;
  background-color: #9ea3ab;
}

.calendar__number {
  text-align: center;
  flex-basis: 14.28%;
  flex-direction: column;
  height: 50px;
  color: #262626;
  position: relative;
}

.calendar__number div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.today {
  height: 50px;
  text-align: center;
  flex-basis: 14.28%;
  flex-direction: column;
  color: white;
  position: relative;
}

.past {
  text-align: center;
  flex-basis: 14.28%;
  flex-direction: column;
  height: 50px;
  color: #9ea3ab;
}

.today div {
  width: 12vw;
  height: 12vw;
  max-width: 40px;
  background-color: #ff7100;
  border-radius: 50%;
  max-height: 40px;
  padding: 11%;
  margin-top: 6%;
  padding-top: 12%;
}
.att_sticker {
  max-width: 45px;
  position: relative;
  top: 8px;
}
</style>
